import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-3">
            热门榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            本周人气最高的漫画作品一览
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden">
            <div className="hidden sm:grid grid-cols-12 gap-3 px-5 md:px-6 py-3 bg-background-100 border-b border-background-200/60 text-xs font-medium text-foreground-500">
              <span className="col-span-1 text-center">排名</span>
              <span className="col-span-4">作品</span>
              <span className="col-span-2">作者</span>
              <span className="col-span-2">类型</span>
              <span className="col-span-2">热度</span>
              <span className="col-span-1 text-center">趋势</span>
            </div>

            <div className="divide-y divide-background-200/40">
              {rankingData.map((item, i) => (
                <div
                  key={i}
                  className="grid grid-cols-2 sm:grid-cols-12 gap-3 px-5 md:px-6 py-3.5 md:py-4 items-center hover:bg-background-50 transition-colors cursor-pointer"
                >
                  <div className="sm:col-span-1 flex items-center sm:justify-center gap-2 sm:gap-0">
                    <span className={`w-6 h-6 md:w-7 md:h-7 flex items-center justify-center rounded-md text-xs font-bold ${
                      item.rank === 1 ? 'bg-primary-500 text-background-50' :
                      item.rank === 2 ? 'bg-accent-500 text-background-50' :
                      item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                      'bg-background-200 text-foreground-600'
                    }`}>
                      {item.rank}
                    </span>
                  </div>

                  <div className="sm:col-span-4">
                    <span className="text-sm md:text-base font-semibold text-foreground-900">{item.title}</span>
                  </div>

                  <div className="sm:col-span-2">
                    <span className="text-xs md:text-sm text-foreground-500">{item.author}</span>
                  </div>

                  <div className="sm:col-span-2">
                    <span className="inline-block px-2 py-0.5 rounded text-[10px] md:text-xs font-medium bg-background-100 text-foreground-600 whitespace-nowrap">
                      {item.genre}
                    </span>
                  </div>

                  <div className="sm:col-span-2 flex items-center gap-2">
                    <div className="flex-1 h-1.5 rounded-full bg-background-200 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-primary-500"
                        style={{ width: `${parseFloat(item.heat) * 10}%` }}
                      ></div>
                    </div>
                    <span className="text-xs font-semibold text-primary-600 whitespace-nowrap">{item.heat}</span>
                  </div>

                  <div className="sm:col-span-1 flex sm:justify-center">
                    <i className={`text-sm ${
                      item.change === 'up' ? 'ri-arrow-up-line text-primary-500' :
                      item.change === 'down' ? 'ri-arrow-down-line text-foreground-400' :
                      item.change === 'new' ? 'ri-shining-line text-accent-500' :
                      'ri-subtract-line text-foreground-400'
                    }`}></i>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}